export const HIGHLIGHT_THRESHOLDS = {
  percent_valid_addresses: 50,
  percent_valid_automated_phones: 10,
  percent_duplicate_forms: 10,
  manual_wrong_numbers_per_verified_number: 0.5,
  percent_manual_wrong_number: 30,
  percent_manual_failed_verification: 30,
}
